// extracted by mini-css-extract-plugin
export default {"root":"_1AbaI","heading-and-subheading-block":"jtoGj","headingAndSubheadingBlock":"jtoGj","subheading":"_29ohN"};